import { parseFontDefinition } from './helpers';
import type { FontDefinition } from './types';

/**
 * Display typography tokens
 * @see [Figma Typography](https://www.figma.com/design/woVU3YEkhjcXBvQ2gnTXm4/Kos-QA?node-id=27-2159)
 */
const displayDefinition: FontDefinition = {
  default: {
    fontFamily: 'Inter',
    size: 60,
    weight: '500',
    lineHeight: 60,
    letterSpacing: '0',
  },
  variants: {
    XL: {
      size: 120,
      lineHeight: 120,
      weight: '600',
    },
    L_Regular: {
      size: 60,
      lineHeight: 60,
      weight: '400',
    },
    L_Medium: {
      size: 60,
      lineHeight: 60,
      weight: '500',
    },
    M_Regular: {
      size: 32,
      lineHeight: 32,
      weight: '400',
    },
    M_Medium: {
      size: 32,
      lineHeight: 32,
      weight: '500',
    },
  },
};

/**
 * Metric typography tokens
 * @see [Figma Typography](https://www.figma.com/design/woVU3YEkhjcXBvQ2gnTXm4/Kos-QA?node-id=27-2159)
 */
const metricDefinition: FontDefinition = {
  default: {
    fontFamily: 'Inter',
    size: 16,
    weight: '400',
    lineHeight: 16,
    letterSpacing: '0',
  },
  variants: {
    L_Regular: {
      size: 20,
      lineHeight: 20,
      weight: '400',
    },
    L_Medium: {
      size: 20,
      lineHeight: 20,
      weight: '500',
    },
    M_Regular: {
      size: 16,
      lineHeight: 16,
      weight: '400',
    },
    M_Medium: {
      size: 16,
      lineHeight: 16,
      weight: '500',
    },
    S_Regular: {
      size: 14,
      lineHeight: 14,
      weight: '400',
    },
    S_Medium: {
      size: 14,
      lineHeight: 14,
      weight: '500',
    },
  },
};

/**
 * Heading typography tokens (H1-H5 equivalents)
 * @see [Figma Typography](https://www.figma.com/design/woVU3YEkhjcXBvQ2gnTXm4/Kos-QA?node-id=27-2159)
 */
const headingsDefinition: FontDefinition = {
  default: {
    fontFamily: 'Inter',
    size: 32,
    weight: '600',
    lineHeight: 32,
    letterSpacing: '0',
  },
  variants: {
    L_SemiBold: {
      size: 32,
      lineHeight: 40,
    },
    M_SemiBold: {
      size: 24,
      lineHeight: 32,
    },
    S_SemiBold: {
      size: 20,
      lineHeight: 24,
    },
    XS_SemiBold: {
      size: 18,
      lineHeight: 28,
    },
    XXS_SemiBold: {
      size: 16,
      lineHeight: 24,
    },
  },
};

/**
 * Body typography tokens
 * @see [Figma Typography](https://www.figma.com/design/woVU3YEkhjcXBvQ2gnTXm4/Kos-QA?node-id=27-2159)
 */
const bodyDefinition: FontDefinition = {
  default: {
    fontFamily: 'Inter',
    size: 16,
    weight: '400',
    lineHeight: 24,
    letterSpacing: '0',
  },
  variants: {
    L_Regular: {
      size: 18,
      lineHeight: 28,
    },
    L_SemiBold: {
      size: 18,
      lineHeight: 28,
      weight: '600',
    },
    M_Regular: {
      size: 16,
      lineHeight: 24,
    },
    M_SemiBold: {
      size: 16,
      lineHeight: 24,
      weight: '600',
    },
    S_Regular: {
      size: 14,
      lineHeight: 20,
    },
    S_Medium: {
      size: 14,
      lineHeight: 20,
      weight: '500',
    },
    S_SemiBold: {
      size: 14,
      lineHeight: 20,
      weight: '600',
    },
    XS_Medium: {
      size: 12,
      lineHeight: 16,
      weight: '500',
    },
    XS_SemiBold: {
      size: 12,
      lineHeight: 16,
      weight: '600',
    },
  },
};

export const typography = {
  display: parseFontDefinition(displayDefinition),
  metric: parseFontDefinition(metricDefinition),
  headings: parseFontDefinition(headingsDefinition),
  body: parseFontDefinition(bodyDefinition),
};
